export default "__VITE_ASSET__BnpGNNAZ__"